import { hideChat, showChat } from 'Services/chat';
import { history } from 'Store';
import { routes } from 'Constants/routes';
import { handleUserHeader, removeOverflow } from 'Styles/utils/utils';
import TaxesIcon from './icons/TaxesIcon';
import PlansIcon from './icons/PlansIcon';
import HelpIcon from './icons/HelpIcon';
import AccountIcon from './icons/AccountIcon';
import ReferralIcon from './icons/ReferralIcon';
import PreviousYearsIcon from './icons/PreviousYearsIcon';

// eslint-disable-next-line no-shadow
export enum NavItemsIds {
  TAXES = 'taxes',
  PLANS = 'plans',
  PREVIOUS_YEARS = 'previous_years',
  REFERRAL = 'referral',
  HELP = 'help',
  ACCOUNT = 'account',
}

const openHelp = (): void => {
  removeOverflow();
  showChat();
};

const closeNav = (): void => {
  handleUserHeader();
};

const goToRoute = (route: string): void => {
  history.push(route);
  closeNav();
  hideChat();
  removeOverflow();
};

export const userLinks = [
  {
    id: NavItemsIds.TAXES,
    label: 'Header.taxes',
    action: (): void => goToRoute(routes.DASHBOARD),
    Icon: TaxesIcon,
    route: routes.DASHBOARD,
  },
  {
    id: NavItemsIds.PREVIOUS_YEARS,
    label: 'Header.previousYears',
    action: (): void => goToRoute(routes.PREVIOUS_YEARS_INFO),
    Icon: PreviousYearsIcon,
    route: routes.PREVIOUS_YEARS_INFO,
  },
  {
    id: NavItemsIds.PLANS,
    label: 'Header.plans',
    action: (): void => goToRoute(routes.PLANS),
    Icon: PlansIcon,
    route: routes.PLANS,
  },
  {
    id: NavItemsIds.REFERRAL,
    label: 'Links.referral',
    action: (): void => goToRoute(routes.REFERRAL),
    Icon: ReferralIcon,
    condition: (flag: boolean): boolean => flag,
    route: routes.REFERRAL,
  },
  {
    id: NavItemsIds.HELP,
    label: 'Header.help',
    action: openHelp,
    Icon: HelpIcon,
  },
  {
    id: NavItemsIds.ACCOUNT,
    label: 'Header.account',
    action: (): void => goToRoute(routes.ACCOUNT),
    Icon: AccountIcon,
    route: routes.ACCOUNT,
  },
];
